<div class="flex justify-end my-8">
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="printQuotation()"
  >
    Print
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="emailQuotation()"
  >
    Email
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 ml-8 mr-32"
    (click)="openPDF()"
  >
    Download
  </button>
</div>

<!-- preview page 1 -->
<div class="flex flex-col p-16 mb-6 border" id="print-section">
  <header><img src="../../../assets/dlm-images/dlm/dlm-header.png" /></header>

  <table class="print-content">
    <thead>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="flex justify-center my-16 w-full">
            <h1 class="">
              {{ "QUOTATION R" + model?.quoteId }}
            </h1>
          </div>
          <div
            class="flex flex-col general-details-container justify-center items-center my-16 w-full avoid-break"
          >
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Customer</div>
              <div class="data cell px-8 w-70">
                {{ model?.customerName }}
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Contact</div>
              <div class="data cell px-8 w-70">
                {{ model?.quoteContactName }}
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Email Address</div>
              <div class="data cell px-8 w-70">
                {{ model?.quoteContactEmail }}
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Date</div>
              <div class="data cell px-8 w-70">
                <div class="flex flex-row">
                  {{ model?.date | date: "dd/MM/YYYY" }}
                </div>
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Sales Order No</div>
              <div class="data cell px-8 w-70">
                <div
                  class="flex flex-row"
                  *ngFor="let salesOrder of model?.salesOrders"
                >
                  {{ salesOrder }}
                </div>
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Equipment Submitted</div>
              <div class="data cell flex flex-col px-8 w-70">
                <ng-container *ngFor="let equipment of getEquipmentList()">
                  <p class="mb-0">
                    <!-- {{
                      model?.serialNumbers?.length > 1
                        ? model?.serialNumbers.length + "x"
                        : ""
                    }} -->
                    <!-- {{ model?.workingLoadLimits[i] }} {{ model?.loadCellTypes[i] }} -->
                      {{equipment}}
                  </p>
                </ng-container>
                <!-- <ng-container *ngFor="let part of model?.formParts">
                  <p class="mb-0">
                    {{ part?.quantity + "x " + part?.partOption?.description }}
                  </p>
                </ng-container> -->
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Serial No</div>
              <div class="data cell flex flex-col px-8 w-70">
                <ng-container *ngFor="let serialNumber of model?.serialNumbers">
                  <p class="mb-0">
                    {{ serialNumber }}
                  </p>
                </ng-container>
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">Purchase Order No</div>
              <div class="data cell px-8 w-70">
                <div
                  class="flex flex-row"
                  *ngFor="let purchaseOrder of model?.purchaseOrders"
                >
                  {{ purchaseOrder }}
                </div>
              </div>
            </div>
            <div class="flex flex-row items-stretch w-80">
              <div class=" title cell px-8 w-30">DLM Contact</div>
              <div class="data cell px-8 w-70">
                {{ currentUser }}
              </div>
            </div>
            <div class="flex flex-row items-stretch w-90 mt-32 mb-0">
              <p class="mb-0">
                Thank you for considering DLM. Our <strong>preliminary inspection</strong> of
                your equipment has resulted in the report set out below. We must
                emphasise that our investigation so far has only been a <u>visual
                inspection</u> and a <u>bench test</u>, the remedial action detailed below
                will serve only to enable us to proceed with further, dynamic
                tests. This later stage of testing may reveal further faults
                with the equipment which may necessitate further rectification
                at <u>additional cost</u>. The authorisation now sought from you is for
                us to proceed with the initial rectification outlined below, at
                the cost shown. We would require written an order authorising
                the incurring of the costs detailed before proceeding to the
                second stage of investigation. Please be aware that we are
                unable to accept verbal authorisation alone to proceed with
                work. Should any further fault be found after this stage we
                shall re-quote and await an amended order before proceeding with
                the work.
              </p>
            </div>
          </div>
          <div
            class="flex flex-col justify-center items-center my-16 w-full avoid-break"
          >
            <div class="cell flex flex-row items-stretch w-90">
              <div class="px-8 mb-4">
                <p class=" text-box">
                  Fault conditions revealed by preliminary test:
                </p>
                <div
                  class="flex flex-row"
                  *ngFor="let fault of groupFaultsFound()"
                >
                  <p class=" mr-4 mb-0">{{ fault.serialNumber + ": " }}</p>
                  <p class="mb-0" style="white-space: preserve-breaks">
                    {{ getFaultDescription(fault) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="cell flex flex-row items-stretch w-90">
              <div class="px-8 mb-4">
                <p class=" text-box">
                  Rectification work required before second stage testing:
                </p>
                <div
                  class="flex flex-row"
                  *ngFor="let workRequired of groupRectificationWorks()"
                >
                  <p class=" mr-4 mb-0">
                    {{ workRequired.serialNumber + ": " }}
                  </p>
                  <p class="mb-0" style="white-space: preserve-breaks">
                    {{ getRectificationWork(workRequired) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </tfoot>
  </table>

  <footer><img src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" /></footer>
</div>


<!-- preview page 2 -->
<div class="flex flex-col p-16 mb-6 border">
  <header><img src="../../../assets/dlm-images/dlm/dlm-header.png" /></header>

  <table class="print-content">
    <thead>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div
            class="flex flex-col justify-center items-center my-16 w-full avoid-break"
          >
            <div class="flex flex-row w-90">
              <div class="cell flex flex-col w-50">
                <div class="px-8">
                  <p class=" text-box">Parts:</p>
                  <div class="flex flex-row justify-between w-full">
                    <p class=" flex flex-col w-50">Description</p>
                    <p class=" flex flex-col center-text w-20">Qty</p>
                    <p class=" flex flex-col center-text w-20">
                      Price
                    </p>
                    <p class=" flex flex-col center-text w-20">
                      Total
                    </p>
                  </div>
                  <div *ngFor="let part of model?.formParts">
                    <div class="flex flex-row justify-between w-full">
                      <p class=" flex flex-col w-50">
                        {{ part?.partOption?.description }}
                      </p>
                      <span class=" flex flex-col center-text w-20">
                        {{ part?.quantity }}
                      </span>
                      <span class=" flex flex-col center-text w-20">
                        {{
                          (part?.partOption?.number == "3rd Party"
                          ? part?.cost
                          : part?.partOption?.cost) *
                            (part?.partOption?.markup + 1) | currency: "GBP"
                        }}
                      </span>
                      <span class=" flex flex-col center-text w-20">
                        {{
                          (part?.partOption?.number == "3rd Party"
                          ? part?.cost
                          : part?.partOption?.cost) *
                            (part?.partOption?.markup + 1) *
                            part?.quantity | currency: "GBP"
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-row justify-between w-full">
                    <p class=" flex flex-col w-50">Parts Cost</p>
                    <span
                      class=" flex flex-col center-text w-20"
                    ></span>
                    <span
                      class=" flex flex-col center-text w-20"
                    ></span>
                    <span class=" flex flex-col center-text w-20">
                      {{ getTotalPartsCost() | currency: "GBP" }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="cell flex flex-col w-50">
                <div class="px-8">
                  <p class=" text-box">
                    Cost of preliminary work detailed above:
                  </p>
                  <div class="flex flex-row justify-between w-full">
                    <span class="flex flex-col w-20"></span>
                    <span class=" flex flex-col center-text w-20">
                      Qty
                    </span>
                    <span class=" flex flex-col center-text w-20">
                      Cost
                    </span>
                    <p class=" flex flex-col center-text w-20">
                      Total
                    </p>
                  </div>
                  <div class="flex flex-row justify-between w-full">
                    <p class=" flex flex-col w-60">Labour</p>
                    <p class=" flex flex-col center-text w-20">
                      {{ model?.labourHours | currency: "GBP" }}
                    </p>
                  </div>
                  <div class="flex flex-row justify-between w-full">
                    <p class=" flex flex-col w-60">Parts</p>
                    <p class=" flex flex-col center-text w-20">
                      {{ getTotalPartsCost() | currency: "GBP" }}
                    </p>
                  </div>

                  <ng-container>
                    <div class="flex flex-row justify-between w-full">
                      <p class=" flex flex-col w-20">Calibration</p>
                      <span class=" flex flex-col center-text w-20">
                        {{ model?.calibrationFeeBreakdown?.length || 1 }}
                      </span>
                      <span class=" flex flex-col center-text w-20">
                        {{ (model?.calibrationFee ?? 0) / (model?.calibrationFeeBreakdown?.length || 1) | currency: "GBP" }}
                      </span>
                      <p class=" flex flex-col center-text w-20">
                        {{ model?.calibrationFee | currency: "GBP" }}
                      </p>
                    </div>
                  </ng-container>
                  <!-- <ng-container
                    *ngFor="let fee of model?.calibrationFeeBreakdown"
                  >
                    <div class="flex flex-row justify-between w-full">
                      <p class=" flex flex-col w-60 italic">
                        Calibration {{ fee.description }}
                      </p>
                      <p class=" flex flex-col center-text w-20"> -->
                        <!-- {{ fee.calibrationFee | currency: "GBP" }} -->
                      <!-- </p>
                    </div>
                  </ng-container> -->

                  <div class="flex flex-row justify-between w-full">
                    <p class=" flex flex-col w-60">Carriage</p>
                    <p class=" flex flex-col center-text w-20">
                      {{ model?.carriage | currency: "GBP" }}
                    </p>
                  </div>
                  <div
                    class="flex flex-row justify-between w-full"
                    *ngIf="showPressureTestCost()"
                  >
                    <p class=" flex flex-col w-60">
                      Pressure Test Cost
                    </p>
                    <p class=" flex flex-col center-text w-20">
                      {{ model?.pressureTestCost | currency: "GBP" }}
                    </p>
                  </div>
                  <div class="flex flex-row justify-between w-full">
                    <p class=" flex flex-col w-60">Total</p>
                    <p class=" flex flex-col center-text w-20">
                      {{ model?.total | currency: "GBP" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="text-center">
            NB: The figures shown for these costs do not include VAT, which will be added where applicable.<br/>
            In the event that this quote is unsuccessful for any of the equipment listed, inspection fee per item and carriage<br/>
            charges are applicable.</p>


          <ng-container *ngIf="urls?.length > 0">
            <div class="w-90 mx-auto mt-32">
              <h2>Images of your Submitted Equipment</h2>
              <p>The images below show the loadcell received.</p>
              <p>This photo serves as a reference for the item assessed under this quotation.</p>

              <div class="flex flex-row flex-wrap">
                <ng-container *ngFor="let url of this.urls; let i = index">
                  <div class="mySlides flex flex-col gap-2">
                    <img [src]="url" />
                    <mat-checkbox
                        [color]="'primary'"
                        [checked]="imageIsIncluded(i)"
                        (change)="toggleIncludeImage(i)">
                        Include in PDF
                    </mat-checkbox>
                  </div>
                </ng-container>
              </div>
            </div>
            
          </ng-container>

        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </tfoot>
  </table>

  <footer><img src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" /></footer>
</div>


<!-- preview page 3 -->
<div class="flex flex-col p-16 mb-6 border">
  <header><img src="../../../assets/dlm-images/dlm/dlm-header.png" /></header>

  <table class="print-content">
    <thead>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          
          <div class="flex justify-center my-16 w-full">
            <h1 class="">
              CUSTOMER AUTHORISATION
            </h1>
          </div>
          
          <p>
            We authorise you to continue with the preliminary rectification work described and we accept the costs shown, together
            with carriage charges and VAT as applicable, in respect of which our order number is detailed below.
          </p>
          <p>Customer:</p>
          <p>Sales Order Number:</p>
          <p>Quote Number:</p>
          <p>Order Number: ………………………………………………………………………</p>
          <p>Delivery Address: ………………………………………………………………………</p>
          <p>Print Name: ………………………………………………………………………</p>
          <p>Signed: ………………………………………………………………………</p>
          <p>Date: ………………………………………………………………………</p>
          <p>&nbsp;</p>
          <p class="mt-8">Subject to DLM's standard terms and conditions</p>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </tfoot>
  </table>

  <footer><img src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" /></footer>
</div>


<!-- Print stuff -->
<div id="print-header" style="display: none;">
  <img class="pt-32 px-32" src="../../../assets/dlm-images/dlm/dlm-header.png" />
</div>

<div id="print-footer" style="display: none;">
  <img class="p-32" src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" />
</div>

<div id="print-images" style="display: none;">
  <div class="flex flex-row flex-wrap gap-2 px-48 justify-center">
    <ng-container *ngFor="let url of getIncludedImages(); let i = index">
      <div class="mySlides">
        <img [src]="url" />
      </div>
    </ng-container>
  </div>
</div>
